import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import MapComponent from "../../../../components/Dashboard/NewRoute/MapComponent";
import MenuButtons from "../../../../components/Dashboard/NewRoute/MenuButtons";
import TooltipDistandeAndTime from "../../../../components/Dashboard/NewRoute/TooltipDistandeAndTime";
import FormGenerateNewRoute from "../../../../components/Dashboard/NewRoute/FormGenerateNewRoute";
import InputDrawRoute from "../../../../components/Dashboard/NewRoute/InputDrawRoute";
import "./animation.css";
import Loading from "../../../../components/Loading/Loading";
import MenuActionsMap from "../../../../components/Dashboard/NewRoute/MenuActionsMap";
import ModalSaveRoute from "../../../../components/Dashboard/Modals/ModalSaveRoute/ModalSaveRoute";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import ModalLimitOfRoutes from "../../../../components/Dashboard/ModalLimitOfRoutes/ModalLimitOfRoutes";

const MapboxMap = () => {
  const { route } = useSelector((state) => state.routeReducer);
  const [buttonSelected, setButtonSelected] = useState("draw");
  const [showModalLimitRoutes, setShowModalLimitRoutes] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (route?.landMarks?.length < 1) {
      toast.error("La ruta debe de tener por lo menos 2 puntos.");
      return;
    }
    setOpen(true);
  };
  const [loading, setLoading] = useState(false);
  const [animationState, setAnimationState] = useState({
    visible: false,
    direction: "left",
    currentForm: null,
  });

  const handleButtonClick = (action, direction) => {
    // Si ya está seleccionado, ocultar
    if (buttonSelected === action) {
      setAnimationState({
        visible: false,
        direction: direction,
        currentForm: null,
      });
      setButtonSelected("draw");
      return;
    }

    // Configurar la animación según el botón seleccionado
    setAnimationState({
      visible: true,
      direction: direction,
      currentForm: action,
    });
    setButtonSelected(action);
  };

  return (
    <Container
      maxWidth="xl"
      style={{ position: "relative", margin: 0, marginTop: -30, padding: 0 }}
    >
      <TooltipDistandeAndTime />
      <MenuActionsMap handleOpen={handleOpen} />
      <Box
        sx={{
          position: "absolute",
          top: { xs: 80, sm: 20 },
          left: 45,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: 280,
          gap: 4,
          zIndex: 1,
        }}
      >
        <MenuButtons
          buttonSelected={buttonSelected}
          onButtonClick={handleButtonClick}
        />

        <div className="form-animation-container">
          {animationState.visible && (
            <div
              className={`animated-form ${
                animationState.direction === "left"
                  ? "slide-in-left"
                  : "slide-in-right"
              }`}
            >
              {animationState.currentForm === "generateRoute" ? (
                <FormGenerateNewRoute setLoading={setLoading} />
              ) : animationState.currentForm === "selectedPoints" ? (
                <InputDrawRoute setLoading={setLoading} />
              ) : null}
            </div>
          )}
        </div>
      </Box>
      <Box sx={{ width: "100%", height: "100vh" }}>
        <MapComponent setLoading={setLoading} />
      </Box>
      <ModalSaveRoute
        open={open}
        setOpen={setOpen}
        setLoading={setLoading}
        setShowModalLimitRoutes={setShowModalLimitRoutes}
      />
      <ModalLimitOfRoutes
        onClose={() => setShowModalLimitRoutes(false)}
        open={showModalLimitRoutes}
      />
      <Loading loading={loading} />
    </Container>
  );
};

export default MapboxMap;
